// Exports location components which touch maplibre-gs wrapped in React Suspense to enable code splitting

import React, { type JSX, type ComponentProps, lazy, Suspense } from "react";

import Spinner from "../elements/Spinner";

const MapComponent = lazy(() => import("./Map"));

export function Map(props: ComponentProps<typeof MapComponent>): JSX.Element {
    return (
        <Suspense fallback={<Spinner />}>
            <MapComponent {...props} />
        </Suspense>
    );
}

const SmartMarkerComponent = lazy(() => import("./SmartMarker"));

export function SmartMarker(props: ComponentProps<typeof SmartMarkerComponent>): JSX.Element {
    return (
        <Suspense fallback={<Spinner />}>
            <SmartMarkerComponent {...props} />
        </Suspense>
    );
}

const LocationButtonComponent = lazy(() => import("./LocationButton"));

export function LocationButton(props: ComponentProps<typeof LocationButtonComponent>): JSX.Element {
    return (
        // <Suspense fallback={<Spinner />}>
            <LocationButtonComponent {...props} />
        // </Suspense>
    );
}

const LocationViewDialogComponent = lazy(() => import("./LocationViewDialog"));

export function LocationViewDialog(props: ComponentProps<typeof LocationViewDialogComponent>): JSX.Element {
    return (
        <Suspense fallback={<Spinner />}>
            <LocationViewDialogComponent {...props} />
        </Suspense>
    );
}

// LocationMapTile handles its own internal lazy loading of Map,
// so it does not need a Suspense wrapper here.
export { LocationMapTile } from "./LocationMapTile";
export type { LocationMapTileProps } from "./LocationMapTile";
